import { EventEmitter } from '@angular/core';
import { ButtonsActionsTableComponent } from '@app/shared';

export class CondictionComponentConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor() {}

  /**
   * Crea la configuracion para la tabla de condiciones de las formas
   *
   * @returns {*}
   * @memberof CondictionComponentConfig
   */
  getTableCondictionsForm(): any {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay formas',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        formaInicia: {
          editable: false,
          addable: false,
          title: 'Forma inicia',
          filter: {
            inputClass: 'form-control',
          },
        },
        formularioInicia: {
          editable: false,
          addable: false,
          title: 'Formulario inicia',
          filter: {
            inputClass: 'form-control',
          },
        },
        campoInicia: {
          editable: false,
          addable: false,
          title: 'Campo inicia',
          filter: {
            inputClass: 'form-control',
          },
        },
        siEs: {
          editable: false,
          addable: false,
          title: 'Si es',
          filter: {
            inputClass: 'form-control',
          },
        },
        value: {
          editable: false,
          addable: false,
          title: 'Valor',
          filter: {
            inputClass: 'form-control',
          },
        },
        accion: {
          editable: false,
          addable: false,
          title: 'Accion',
          filter: {
            inputClass: 'form-control',
          },
        },
        formularioCondicionado: {
          editable: false,
          addable: false,
          title: 'Formulario condicionado',
          filter: {
            inputClass: 'form-control',
          },
        },
        campoCondicionado: {
          editable: false,
          addable: false,
          title: 'Campo condicionado',
          filter: {
            inputClass: 'form-control',
          },
        },
        valueAsignar: {
          editable: false,
          addable: false,
          title: 'Valor a asignar',
          filter: {
            inputClass: 'form-control',
          },
        },
        operadorCondicion: {
          editable: false,
          addable: false,
          title: 'Siguiente operador de condicion',
          filter: {
            inputClass: 'form-control',
          },
        },
        idForma: {
          title: 'Acciones',
          filter: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };

    return this.settings;
  }

  /**
   * Crea la configuracion de la tabla de condiciones para los campos de los formularios
   *
   * @returns {*}
   * @memberof CondictionComponentConfig
   */
  getTableCondictionsControl(): any {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay formas',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        campoDepende: {
          editable: false,
          addable: false,
          title: 'Depende de',
          filter: {
            inputClass: 'form-control',
          },
        },
        siEs: {
          editable: false,
          addable: false,
          title: 'Si es',
          filter: {
            inputClass: 'form-control',
          },
        },
        value: {
          editable: false,
          addable: false,
          title: 'Valor',
          filter: {
            inputClass: 'form-control',
          },
        },
        accion: {
          editable: false,
          addable: false,
          title: 'Acción',
          filter: {
            inputClass: 'form-control',
          },
        },
        valueAsignar: {
          editable: false,
          addable: false,
          title: 'Valor a asignar',
          filter: {
            inputClass: 'form-control',
          },
        },
        operarResultado: {
          editable: false,
          addable: false,
          title: 'Operar resultado',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.operarResultado) {
              return 'Sí';
            } else {
              return 'No';
            }
          }
        },
        mantenerSesion: {
          editable: false,
          addable: false,
          title: 'Mantener resultado en sesión',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.mantenerSesion) {
              return 'Sí';
            } else {
              return 'No';
            }
          }
        },
        operadorCondicion: {
          editable: false,
          addable: false,
          title: 'Siguiente operador de condicion',
          filter: {
            inputClass: 'form-control',
          },
        },
        idForma: {
          title: 'Acciones',
          filter: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };

    return this.settings;
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/conditions/shared/condiction.config.service.ts